/**
 * StatDoughnut — anillo de estado con leyenda, para los centros de operaciones.
 *
 * SVG puro: sin librerías de gráficas, cero peso y funciona con cualquier skin
 * (los colores salen de tokens). Es el mismo dibujo que el anillo de
 * vulnerabilidades, generalizado para que Actualizaciones y Software usen el
 * mismo criterio visual.
 */

import React from 'react';

export default function StatDoughnut({
  title,
  segments = [],
  total = 0,
  centerLabel = 'TOTAL',
  size = 148,
  stroke = 16,
}) {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const suma = total || segments.reduce((n, s) => n + (Number(s.value) || 0), 0);
  let offset = 0;

  return (
    <div style={{ border: '1px solid var(--border)', borderRadius: 14, background: 'var(--bg-card)', padding: '14px 16px' }}>
      {title && <h3 style={{ margin: '0 0 10px', textAlign: 'left', fontSize: 15 }}>{title}</h3>}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <div style={{ position: 'relative', width: size, height: size, flex: '0 0 auto' }}>
          <svg width={size} height={size} role="img" aria-label={title || 'Estado'}>
            <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="var(--border)" strokeWidth={stroke} />
            {segments.filter((s) => Number(s.value) > 0).map((s) => {
              const frac = (Number(s.value) || 0) / Math.max(suma, 1);
              const dash = frac * circumference;
              const el = (
                <circle
                  key={s.label}
                  cx={size / 2}
                  cy={size / 2}
                  r={radius}
                  fill="none"
                  stroke={s.color}
                  strokeWidth={stroke}
                  strokeDasharray={`${dash} ${circumference - dash}`}
                  strokeDashoffset={-offset}
                  transform={`rotate(-90 ${size / 2} ${size / 2})`}
                />
              );
              offset += dash;
              return el;
            })}
          </svg>
          <div
            style={{
              position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center', pointerEvents: 'none',
            }}
          >
            <span style={{ fontSize: 24, fontWeight: 800, lineHeight: 1 }}>{suma}</span>
            <span style={{ fontSize: 10, color: 'var(--text-muted)', letterSpacing: 1 }}>
              {centerLabel}
            </span>
          </div>
        </div>

        <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: 6 }}>
          {segments.map((s) => {
            const pct = suma ? Math.round(((Number(s.value) || 0) / suma) * 100) : 0;
            return (
              <li key={s.label} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                <span style={{ width: 10, height: 10, borderRadius: 3, background: s.color }} />
                <span style={{ minWidth: 92, color: 'var(--text-secondary)' }}>{s.label}</span>
                <strong style={{ minWidth: 40, textAlign: 'right' }}>{s.value || 0}</strong>
                <span style={{ color: 'var(--text-muted)', minWidth: 36, textAlign: 'right' }}>{pct}%</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
